export const minecraft1202 = {
  version: '1.20.2',
  title: 'Trails & Tales Update',
  image: 'https://www.minecraft.net/content/dam/minecraftnet/games/minecraft/key-art/Vanilla-PMP_Collection-Carousel-0_Trails-and-Tales_1280x768.jpg',
  releases: [
    {
      id: "140jA3Yxl",
      version: "1.0.4",
      date: "Jul 5, 2025",
      changelog: "Versión estable para Minecraft 1.20.2 con todos los mods optimizados",
      downloadUrl: "https://modrinth.com/modpack/simonuwu-fabric-project/version/1.0.4-1.20.2",
      curseforgeUrl: "https://www.curseforge.com/minecraft/modpacks/simonuwu-fabric-project",
      isBeta: false
    }
  ]
};